<template>
  <div class="relative inline-flex">
    <Avatar :size="size ?? 'xs'" :shape="shape ?? 'circle'" :identity="identity ?? user?.id" :class="props.class">
      <AvatarImage v-if="user?.attributes.avatar_url" :src="mediaUrl(user.attributes.avatar_url)" />
      <AvatarFallback>{{ initials }}</AvatarFallback>
    </Avatar>
    <div v-if="$slots.indicator" class="absolute -bottom-0.5 -right-0.5">
      <slot name="indicator" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HTMLAttributes } from 'vue'
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import type { AvatarVariants } from '@/components/ui/avatar'
import type { Resource } from '@/api/resources'
import { mediaUrl } from '@/lib/utils'

const props = defineProps<{
  user?: Resource<'user'> | null
  // What the hue hashes on, when it must not be the person's id: a CREW's
  // colour keys on the crew, because its lead arrives with a later fetch and a
  // chip that repaints mid-load is the flicker his QA caught.
  identity?: string | null
  size?: AvatarVariants['size']
  shape?: AvatarVariants['shape']
  class?: HTMLAttributes['class']
}>()

const initials = computed(() => {
  const { first_name, last_name } = props.user?.attributes ?? {}
  if (first_name && last_name) return `${first_name[0]}${last_name[0]}`.toUpperCase()
  if (first_name) return first_name[0].toUpperCase()
  return '?'
})
</script>
